import { Badge } from 'react-bootstrap';
import { STATUS_COLORS } from '../../lib/wallet/constants';

const StatusBadge = ({ status, className = '' }) => {
    const variant = STATUS_COLORS[status] || 'secondary';
    const label = String(status).replace(/_/g, ' ');

    console.log(label);
    

    return (
        <Badge bg={variant} className={`status-badge text-capitalize ${className}`}>
            {label} 
        </Badge>
    );
};

export default StatusBadge;
